import React, { Component } from "react";
import { connect } from "react-redux";

import "./styles.scss";
import { message, Popconfirm, Spin, Tabs } from "antd";
import { v4 as uuidv4 } from "uuid";
import { PageHeader } from "../../components";
import BankView from "./BankView";
import { getBank } from "../../api";
import * as actionTypes from "../../store/actions/types";

const { TabPane } = Tabs;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewPointWidth: 0,
      viewPointHeight: 0,
      isActiveShadow: false,
      isLoading: false,
      isLoadingMerchant: false,
      activeMerchant: null,
      merchantData: [],
      tabName: "Merchant mapping",
      selectBank: "1",
      tabJson: [],
      newMerchantList: [],
      confirmVisible: false,
      activeKey: "",
      nextKey: null,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  updateWindowDimensions() {
    this.setState({
      viewPointWidth: window.innerWidth,
      viewPointHeight: window.innerHeight,
    });
    //window.removeEventListener('scroll', this.handleOnScroll);
  }

  async componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    window.addEventListener("scroll", this.handleOnScroll);
    await this.getAll();
  }

  handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
    console.log("scrollTop : " + scrollTop);
    //console.log("scrollHeight : " + scrollHeight);
    //console.log("clientHeight :" + clientHeight);
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleOnScroll);
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  inputHandleChange = (event, inputIdentity) => {
    console.log("event", event, inputIdentity);

    let val = null;
    const updateForm = {
      ...this.state.dataForm,
    };
    const updatedFormElement = {
      ...updateForm[inputIdentity],
    };
    //updatedFormElement.touched = true;
    updateForm[inputIdentity] = updatedFormElement;
    updatedFormElement.value = event.target.value;
    let formIsValid = true;
    for (let inputIdentifier in updateForm) {
      formIsValid = updateForm[inputIdentifier].valid && formIsValid;
    }
    this.setState({ dataForm: updateForm, formIsValid: formIsValid });
    console.log("data_form", this.state.dataForm);
  };

  async getAll() {
    this.setState({ isLoading: true });
    try {
      await this.setAllData();
      this.setState({ isLoading: false });
    } catch (error) {
      console.error("Error fetching data", error);
      this.setState({ isLoading: false });
    }
  }

  async setAllData() {
    let resBank = await getBank();
    const tabJson = await this.syncBank(resBank.data);
    this.setState({
      tabJson: tabJson,
      activeKey: tabJson?.[0]?.id,
    });
  }

  async syncBank(res) {
    let resList = [];
    for (let data of res) {
      resList.push({
        id: data.bankId,
        key: data.bankId,
        tabName: data.bankName,
        content: <BankView bankData={data} />,
      });
    }
    return resList;
  }

  handleChange = (tabName) => {
    this.setState({
      selectBank: tabName,
    });
    let bank = this.state.tabJson.find((item) => item.key === tabName);
    this.props.onClickSelectBank(bank);
  };

  confirmChange = () => {
    this.setState({
      activeKey: this.state.nextKey,
      confirmVisible: false,
    });
  };

  cancelChange = () => {
    this.setState({
      nextKey: null,
      confirmVisible: false,
    });
    // setNextKey(null);
    // setConfirmVisible(false);
    message.info("Tab change cancelled");
  };

  render() {
    const { tabJson, isLoading, viewPointHeight } = this.state;
    const {} = this.props;

    return (
      <>
        <div className={"cco__page-header-wrapper"}>
          <PageHeader
            option={"d-flex justify-content-between"}
            isRefresh={false}
            isDate={false}
            isLoading={isLoading}
            // onClickRefresh={async () => {
            //   let res = await this.getUsers();
            // }}
            title={"Create Offers"}
          />
        </div>

        <div className={"cco__createOffer-body-wrapper"}>
          {!isLoading && (
            <>
              {tabJson?.length > 0 && (
                <div className={"cco__cbw-tab"}>
                  <Popconfirm
                    title="Are you sure you want to switch tabs?"
                    visible={this.state.confirmVisible}
                    onConfirm={this.confirmChange}
                    onCancel={this.cancelChange}
                    placement="topRight"
                    okText="Yes"
                    cancelText="No"
                  >
                    <Tabs
                      onChange={this.handleChange}
                      accessKey={this.state.activeKey}
                      // items={(tabJson || []).map((i) => ({
                      //   label: i.tabName,
                      //   key: i.key,
                      //   children: i.content,
                      // }))}
                    >
                      {((tabJson && tabJson) || []).map((i, t) => (
                        <TabPane tab={i.tabName} key={i.key}>
                          <>{i.content}</>
                        </TabPane>
                      ))}
                    </Tabs>
                  </Popconfirm>
                </div>
              )}
            </>
          )}

          {isLoading && (
            <div style={{ margin: "0 50%", opacity: 0.5 }}>
              <Spin size="large" spinning={isLoading} />
            </div>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return {
    onClickSelectBank: (data) =>
      dispatch({ type: actionTypes.SET_SELECTED_BANK, payload: data }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
